// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/invitations/invitations.actions.go

export const RESEND = "mondoo.invitations.InvitationManager.Resend";
